import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BotonWhatsappFlotante from "../atoms/BotonWhatsappFlotante/BotonWhatsappFlotante"

const BotonWhatsappInicio = () => {
  const data = useStaticQuery(graphql`
    {
      pionero {
        page(id: "675", idType: DATABASE_ID) {
          general {
            links {
              texto
              tipo
              valor
            }
          }
        }
      }
    }
  `)

  const links = data?.pionero?.page?.general?.links || []
  const whatsapp = links.find(link => link.tipo === "whatsapp")

  return <BotonWhatsappFlotante href={whatsapp?.valor} />
}

export default BotonWhatsappInicio
